const status = {
  notstarted: 'notstarted',
  complete: 'complete',
  incomplete: 'incomplete'
}

export default status
